import * as React from "react";

const CrossRefArrow: React.FC = () => {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="#fff"
  >
      <path d="M8,10V13H14V18H8V21L2,15.5L8,10M22,8.5L16,3V6H10V11H16V14L22,8.5Z" />
  </svg>
    );
};

export default React.memo(CrossRefArrow);